import * as Sentry from "@sentry/browser";
import { getEnv } from "@swivu/env";

type CreateSentryProps = {
  app_name: string;
};

export { Sentry };

export function createSentry(
  required: CreateSentryProps,
  sentryOptions?: Sentry.BrowserOptions
): void {
  const environment = getEnv();
  Sentry.init({
    dsn: "https://b3ee8adfa5d3a6ccf29abc7943ac549d@o4507782274088960.ingest.us.sentry.io/4508397955907584",
    sendDefaultPii: true,
    integrations: [],
    environment,
    ...sentryOptions
  });
  Sentry.setTag("app_type", required.app_name);
}
